import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { routes } from '@/presentation/common/router/routes.ts'
import { useSessionStore } from '@/presentation/common/store/zustand/session.ts'

type Props = NonNullable<unknown>

/**
 * This component is used to redirect to login if the user is not authenticated
 * @constructor
 */
export const PrivateRoute: FC<Props> = () => {
  const session = useSessionStore()
  const isAuthenticated = session.accessToken !== null
  return isAuthenticated ? <Outlet/> : <Navigate to={routes.login}/>
}
